import React, { Component } from 'react';
import { connect } from 'react-redux';
import { clearFormInput, formInput } from 'actions/FormActions';
import Drawer from '@mui/material/Drawer';
import Button from 'screens/components/basic/Button';
import DescriptionIcon from '@mui/icons-material/Description';
import { showSnackbar } from 'actions/CommonActions';
import { deleteReportAutomationInfo, getReportAutomationInfo, submitReportAutomation, updateReportAutomationInfo } from 'actions/EntityActions';
import "./Styles/automationDrawerStyle.css";
import BranchEmailTable from './AddOnComponents/BranchEmailTable';
import ConfirmationSection from './AddOnComponents/ConfirmationSection';

class AutomationDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editingRow: null,
      editingColumn: null,
      isUpdate: false,
      isDelete: false,
      editingBranchName: null,
      editingReportId: null,
      editingEmail: null,
      ids: null
    };
    this.handleConfirmUpdate = this.handleConfirmUpdate.bind(this);
    this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
    this.setTableRef = element => {
      this.tableRef = element;
    };
  }

  componentDidMount() {
    const { getReportAutomationInfo, reportId } = this.props;
    getReportAutomationInfo(reportId);
    document.addEventListener('mousedown', this.handleClickOutsideTable);
    document.addEventListener('touchstart', this.handleClickOutsideTable);
  }

  componentDidUpdate(prevProps) {
    const { reportAutomationUpdateDeleteSucess, reportAutomationUpdateFailed, reportAutomationDeleteFailed, getReportAutomationInfo, reportId, showSnackbar, reportAutomationSubmitSuccessTime, reportAutomationSubmitFailedTime, clearFormInput, reportName } = this.props;

    if ((prevProps.reportAutomationSubmitSuccessTime === null && reportAutomationSubmitSuccessTime !== null)
      || (prevProps.reportAutomationSubmitSuccessTime !== reportAutomationSubmitSuccessTime)) {
      clearFormInput(`${reportName}ReportAutomationEmail`);
      getReportAutomationInfo(reportId);
    }

    if ((prevProps.reportAutomationSubmitFailedTime === null && reportAutomationSubmitFailedTime !== null)
      || (prevProps.reportAutomationSubmitFailedTime !== reportAutomationSubmitFailedTime)) {
      this.handleCancelButton();
      showSnackbar("Report Automation Submit Failed!");
    }

    if ((prevProps.reportAutomationUpdateDeleteSucess === null && reportAutomationUpdateDeleteSucess !== null)
      || (prevProps.reportAutomationUpdateDeleteSucess !== reportAutomationUpdateDeleteSucess)) {
      getReportAutomationInfo(reportId);
      this.handleCancelButton();
      showSnackbar("Report Automation Update/Delete Success!");
    }

    if ((prevProps.reportAutomationUpdateFailed === null && reportAutomationUpdateFailed !== null)
      || (prevProps.reportAutomationUpdateFailed !== reportAutomationUpdateFailed)) {
      getReportAutomationInfo(reportId);
      this.handleCancelButton();
      showSnackbar("Report Automation Email Update Failed!");
    }

    if ((prevProps.reportAutomationDeleteFailed === null && reportAutomationDeleteFailed !== null)
      || (prevProps.reportAutomationDeleteFailed !== reportAutomationDeleteFailed)) {
      getReportAutomationInfo(reportId);
      this.handleCancelButton();
      showSnackbar("Report Automation Delete Failed!");
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutsideTable);
    document.removeEventListener('touchstart', this.handleClickOutsideTable);
  }

  isValidEmail = (email) => {
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return emailRegex.test(email);
  };

  submitAutomation = () => {
    const { submitReportAutomation, showSnackbar, reportModel } = this.props;
    const model = reportModel();

    if (!this.isValidEmail(model.Email)) {
      showSnackbar(`Please double check and enter a valid email address.`);
      return;
    }

    for (const key in model) {
      const value = model[key];
      if (
        (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0))
        && (typeof value !== 'boolean')
      ) {
        showSnackbar(`Please double-check your inputs; they can't be empty!`);
        return;
      }
    }
    submitReportAutomation(model);
  };

  handleClickOutsideTable = (event) => {
    if (this.tableRef && !this.tableRef.contains(event.target)) {
      this.setState({ editingRow: null, editingColumn: null, editingBranchName: null, editingReportId: null, editingEmail: null, isUpdate: false, isDelete: false });
      this.props.formInput("", "reportAutomationNewEmailInput");
    }
  };

  handleCellClick = (rowNumber, columnId) => {
    this.setState({ editingRow: rowNumber, editingColumn: columnId });
  };

  handleUpdateButtonClick = (reportId, BranchName, email, ids) => {
    if (!this.props.reportAutomationNewEmailInput) {
      this.props.showSnackbar("Select the email to modify, enter the new address, and click 'Update");
      return;
    }

    if (!this.isValidEmail(this.props.reportAutomationNewEmailInput)) {
      this.props.showSnackbar(`Please double check and enter a valid email address.`);
      return;
    }

    this.setState({ editingBranchName: BranchName, editingReportId: reportId, editingEmail: email, ids:ids, isUpdate: true, isDelete: false });

  };

  handleDeleteButtonClick = (reportId, BranchName, email, ids) => {
    this.setState({ editingBranchName: BranchName, editingReportId: reportId, editingEmail: email, ids:ids, isDelete: true, isUpdate: false });
  };

  handleCancelButton = () => {
    this.setState({ editingRow: null, editingColumn: null, editingBranchName: null, editingReportId: null, editingEmail: null, isUpdate: false, isDelete: false });
    this.props.formInput("", "reportAutomationNewEmailInput");
  };

  handleConfirmUpdate = () => {
    const { reportAutomationNewEmailInput } = this.props;

    if (reportAutomationNewEmailInput != null && this.state.editingReportId != null) {
      const model = {
        Id: this.state.editingReportId,
        Email: reportAutomationNewEmailInput,
        Ids: this.state.ids
      };
      this.props.updateReportAutomationInfo(model);
    }
  };

  handleConfirmDelete = () => {
    if (this.state.editingReportId != null) { this.props.deleteReportAutomationInfo({ reportIds: this.state.ids }); }
  };

  render() {
    const { open, toggleDrawer, drawerContent, name, reportAutomationInfo, headerMessage } = this.props;
    const formattedHeaderMessage = headerMessage.split('\n').map((text, index) => (
      <span key={index}>
        {text}
        <br />
      </span>
    ));

    const textUpdate = `Are you sure to update email from ${this.state.editingEmail} to ${this.props.reportAutomationNewEmailInput} for ${this.state.editingBranchName}?`;
    const textDelete = `Are you sure to remove ${this.state.editingEmail} from ${this.state.editingBranchName}?`;
    return (
      <Drawer
        anchor="right"
        open={open}
        onClose={toggleDrawer}
        sx={{
          '& .MuiDrawer-paper': {
            width: 600,
          },
        }}
      >
        <section>
          <h2 className="automation-header">Report Automation Setup</h2>
          <h5 className="automation-subheader">{name}</h5>
          {formattedHeaderMessage && <h5 className="automation-subheader" style={{ textAlign: "left", margin: "-42px 0 0 10px" }}>{formattedHeaderMessage}</h5>}
          {drawerContent}
          <div className="row">
            <div className="col-lg-12 text-right">
              <Button
                type="IconInButton"
                className="btnNewBrandPOS automation-button"
                name={"Submit"}
                label={"Submit"}
                icon={<DescriptionIcon />}
                onTouchTap={this.submitAutomation}
              />
            </div>
          </div>
        </section>
        {
          reportAutomationInfo && reportAutomationInfo.length > 0 ?
            !this.state.isUpdate && !this.state.isDelete ?
            <div className="row">
            <div className="col-lg-12 pa-1"><BranchEmailTable
                reportAutomationInfo={reportAutomationInfo}
                handleCellClick={this.handleCellClick}
                handleUpdateButtonClick={this.handleUpdateButtonClick}
                handleDeleteButtonClick={this.handleDeleteButtonClick}
                setTableRef={this.setTableRef}
                editingRow={this.state.editingRow}
                editingColumn={this.state.editingColumn}
              /></div>
          </div>
              :
              this.state.isUpdate ?
                <ConfirmationSection text={textUpdate} onCancel={this.handleCancelButton} onConfirm={this.handleConfirmUpdate} setTableRef={this.setTableRef} />
                :
                this.state.isDelete ?
                  <ConfirmationSection text={textDelete} onCancel={this.handleCancelButton} onConfirm={this.handleConfirmDelete} setTableRef={this.setTableRef} />
                  : ""
            : ""
        }
      </Drawer>
    );
  }
}

const mapStateToProps = state => {
  return {
    reportAutomationInfo: state.entity.reportAutomationInfo || [],
    reportAutomationSubmitSuccessTime: state.form.reportAutomationSubmitSuccessTime || null,
    reportAutomationSubmitFailedTime: state.form.reportAutomationSubmitFailedTime || null,
    reportAutomationNewEmailInput: state.form.reportAutomationNewEmailInput || "",
    reportAutomationUpdateDeleteSucess: state.form.reportAutomationUpdateDeleteSucess || null,
    reportAutomationUpdateFailed: state.form.reportAutomationUpdateFailed || null,
    reportAutomationDeleteFailed: state.form.reportAutomationDeleteFailed || null
  };
};

const mapDispatchToProps = dispatch => {
  return {
    formInput: (value, name) => dispatch(formInput(value, name)),
    showSnackbar: (message) => dispatch(showSnackbar(message)),
    submitReportAutomation: (model) => dispatch(submitReportAutomation(model)),
    getReportAutomationInfo: (model) => dispatch(getReportAutomationInfo(model)),
    updateReportAutomationInfo: (model) => dispatch(updateReportAutomationInfo(model)),
    deleteReportAutomationInfo: (model) => dispatch(deleteReportAutomationInfo(model)),
    clearFormInput: (name) => dispatch(clearFormInput(name))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AutomationDrawer);
